import {forwardRef, useMemo, useState} from 'react';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {ButtonV2} from '../../atoms/ButtonV2/ButtonV2';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {InputV2} from '../../atoms/inputV2/inputV2';
import {InputFieldV2Props} from './InputFieldV2Props.interface';

export const InputFieldV2 = forwardRef<HTMLInputElement, InputFieldV2Props>(
  (
    {
      className,
      value,
      type: _type,
      subLabel,
      showCount = false,
      status = 'normal',
      onClickEmailSendButton,
      isDisabledEmailSendButton = false,
      onClickRemoveButton,
      disabled,
      showEmailSendButton,
      emailButtonType = 'button',
      ...props
    },
    ref
  ) => {
    const [showPasswordVisibility, setShowPasswordVisibility] =
      useState<boolean>(false);
    const type = useMemo(() => {
      if (_type === 'password' && showPasswordVisibility) {
        return 'text';
      }
      return _type;
    }, [_type, showPasswordVisibility]);

    return (
      <div>
        <div
          className={twMerge(
            'flex h-48pxr w-full items-center rounded-8pxr border-1 border-solid border-theme-transparent-30 px-18pxr',
            // 일부 안드로이드 웹뷰에서 min-w-auto(default) 일 경우 shrink-0 적용하더라도 컴포넌트 크기가 줄어들지 않아서 추가.
            'min-w-0',
            status === 'error' &&
              'border-static-point-red bg-[rgb(var(--colors-static-point-red)_/_5%)]',
            disabled &&
              'border-theme-transparent-10 cursor-not-allowed bg-theme-solid-10',
            className
          )}
        >
          <InputV2
            value={value}
            disabled={disabled}
            type={type}
            {...props}
            ref={ref}
          />
          {((!disabled && value) || showEmailSendButton) && (
            <div
              className={twMerge(
                'flex items-center ml-4pxr',
                showEmailSendButton && 'shrink-0'
              )}
            >
              {/* 이메일 전송 버튼 */}
              {showEmailSendButton && (
                <ButtonV2
                  type={emailButtonType}
                  disabled={isDisabledEmailSendButton}
                  onClick={onClickEmailSendButton}
                >
                  {t('email_verify_send_button')}
                </ButtonV2>
              )}
              {/* 패스워드 토글 버튼 */}
              {_type === 'password' && (
                <button
                  type="button"
                  onClick={() =>
                    setShowPasswordVisibility(!showPasswordVisibility)
                  }
                >
                  <Icon
                    ariaHidden={false}
                    type={
                      showPasswordVisibility
                        ? IconType.InputboxShowOn
                        : IconType.InputboxShowOff
                    }
                  />
                </button>
              )}
              {/* 텍스트 삭제 버튼 */}
              {onClickRemoveButton && (
                <button type="button" onClick={onClickRemoveButton}>
                  <Icon aria-hidden={false} type={IconType.InputboxDelete} />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);

InputFieldV2.displayName = 'InputFieldV2';
